(function () {
  if (window.__boaDeliveryPriceInitialized) {
    return;
  }
  window.__boaDeliveryPriceInitialized = true;

  const PRICE_LABEL =
    window.themeVariables?.strings?.deliveryPriceLabel || "Shipping";

  function hasValidDeliverySelection(cart) {
    const attributes = cart?.attributes || {};
    const deliveryDate = (attributes.delivery_date || "").trim();
    const branchId = (attributes.branch_verifone_id || "").trim();

    return Boolean(deliveryDate && branchId);
  }

  function getDeliveryPrice(cart) {
    if (!hasValidDeliverySelection(cart)) {
      return null;
    }

    const price = cart?.attributes?.delivery_price;
    if (price === null || price === undefined || price === "" || price === "0" || price === 0) {
      return null;
    }

    return price;
  }

  // Not formatMoney: money_format is amount_no_decimals, so it rounds 24.90 to 25.
  // Same rule as snippets/delivery-price-format.liquid — keep the two in sync.
  // Exported as window.BoaDeliveryPrice.format; boa-shipping-areas.js reuses it.
  function formatDeliveryPrice(priceShekels) {
    const agorot = Math.round(parseFloat(priceShekels) * 100);

    if (!Number.isFinite(agorot)) {
      return "";
    }

    const amount = (agorot / 100).toFixed(agorot % 100 === 0 ? 0 : 2);

    return `${amount} ₪`;
  }

  function buildPriceText(price) {
    return `${PRICE_LABEL}: ${formatDeliveryPrice(price)}`;
  }

  function updateElement(element, price) {
    if (!element) {
      return;
    }

    if (element.hasAttribute("data-delivery-price-locked")) {
      return;
    }

    if (price) {
      element.textContent = buildPriceText(price);
      element.hidden = false;
    } else {
      element.textContent = "";
      element.hidden = true;
    }
  }

  function updateShippingPriceDisplays(cart) {
    const price = getDeliveryPrice(cart);

    document.querySelectorAll("[data-shipping-price-banner]").forEach((element) => {
      updateElement(element, price);
    });
    document.querySelectorAll("[data-shipping-price-product]").forEach((element) => {
      updateElement(element, price);
    });
  }

  function handleCartChange(event) {
    const cart = event?.detail?.cart;
    if (!cart) {
      return;
    }

    updateShippingPriceDisplays(cart);
  }

  document.documentElement.addEventListener("cart:updated", handleCartChange);
  document.documentElement.addEventListener("cart:refresh", handleCartChange);
  document.documentElement.addEventListener("branch:selected", handleCartChange);

  // Shared so boa-shipping-areas.js formats prices identically. Mirrors snippets/delivery-price-format.liquid.
  window.BoaDeliveryPrice = { format: formatDeliveryPrice };
})();
